import * as React from 'react'
import { useReducer, useState } from 'react'
import { timeout } from '../../App'
import GridItem from '../grid/GridItem'
import GridContainer from '../grid/GridContainer'
import CustomInput from '../input/CustomInput'
import Button from '../button/RegularButton'
import Snackbar from '../snackbar/Snackbar'
import { AddAlert } from '@material-ui/icons'
import { initialNotificationState } from '../utils/state/ApplicationState'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { getApiUrl } from '../../api/api'

function parcelReducer(state, action) {
  switch (action.type) {
    case 'field':
      return {
        ...state,
        [action.field]: action.value,
      }
    case 'create':
      return {
        ...state,
      }

    case 'checkbox':
      return {
        ...state,
        registered: !state.registered,
      }

    case 'success':
      return {
        ...initialParcelState,
        success: true,
      }

    case 'error':
      return {
        ...state,
        success: false,
        errorMessage: action.errorMessage,
      }

    default:
      break
  }
  return state
}

const initialParcelState = {
  success: false,
  name: '',
  surname: '',
  room: '',
  registered: false,
  quantity: 1,
}

export default function Parcels() {
  const [state, dispatch] = useReducer(parcelReducer, initialParcelState)
  const [notification, setNotification] = useState(initialNotificationState)

  const submitForm = (e) => {
    e.preventDefault()

    dispatch({ type: 'create' })

    getApiUrl()
      .post(`/admin/parcels`, state)
      .then(function() {
        dispatch({ type: 'success' })
        setNotification({
          open: true,
          message: 'Bewohner wurde informiert.',
          color: 'success',
        })
      })
      .catch(function(error) {
        dispatch({ type: 'error', errorMessage: error })
        setNotification({
          open: true,
          message: error.response.data.message,
          color: 'danger',
        })
      })
      .finally(
        setTimeout(function() {
          setNotification(initialNotificationState)
        }, timeout),
      )
  }

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={3}>
            <CustomInput
              labelText="Vorname"
              id="name"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: state.name,
                type: 'text',
                onChange: (e) =>
                  dispatch({
                    type: 'field',
                    field: 'name',
                    value: e.currentTarget.value,
                  }),
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={3}>
            <CustomInput
              labelText="Nachname"
              id="surname"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: state.surname,
                type: 'text',
                onChange: (e) =>
                  dispatch({
                    type: 'field',
                    field: 'surname',
                    value: e.currentTarget.value,
                  }),
              }}
            />
          </GridItem>
        </GridContainer>
      </GridItem>
      <GridItem xs={12} sm={12} md={12}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={2}>
            <CustomInput
              labelText="Zimmer"
              id="room"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: state.room,
                type: 'text',
                onChange: (e) =>
                  dispatch({
                    type: 'field',
                    field: 'room',
                    value: e.currentTarget.value,
                  }),
              }}
            />
          </GridItem>
        </GridContainer>
      </GridItem>
      <GridItem xs={12} sm={12} md={12}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={2}>
            <CustomInput
              labelText="Anzahl"
              id="quantity"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{
                value: state.quantity,
                type: 'number',
                onChange: (e) =>
                  dispatch({
                    type: 'field',
                    field: 'quantity',
                    value: e.currentTarget.value,
                  }),
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={1}>
            <FormControlLabel
              value="registered"
              control={
                <Checkbox
                  checked={state.registered}
                  onChange={() =>
                    dispatch({
                      type: 'checkbox',
                    })
                  }
                />
              }
              style={{ marginTop: '43px' }}
              label="Einschreiben"
              labelPlacement="end"
            />
          </GridItem>
        </GridContainer>
      </GridItem>
      <GridItem xs={12} sm={12} md={12}>
        <br/>
        <GridContainer>
          <GridItem xs={12} sm={12} md={2}>
            <Button
              color="primary"
              onClick={(e) => {
                submitForm(e)
              }}>
              hinzufügen
            </Button>
          </GridItem>
        </GridContainer>
        <Snackbar
          place="br"
          color={notification.color}
          icon={AddAlert}
          message={notification.message}
          open={notification.open}
          closeNotification={() =>
            setNotification({
              open: false,
              message: '',
              color: '',
            })
          }
          close
        />
      </GridItem>
    </GridContainer>
  )
}
